import { useCallback, useState } from 'react';
import { config, useSpring } from 'react-spring';
import { useElementSize } from 'reactApp/hooks/useElementSize';

export function useOpenTransition({ openDefault = false }: { openDefault: boolean }) {
    const [isOpen, setIsOpen] = useState(openDefault);
    const [immediate, setImmediate] = useState(true);
    const [measureRef, _, { height }] = useElementSize();
    const toggleExpand = useCallback(() => {
        setIsOpen((val) => !val);
        setImmediate(false);
    }, []);

    const style = useSpring({
        immediate,
        config: config.default,
        from: {
            height: 0,
            opacity: 0,
        },
        to: {
            height: isOpen ? height : 0,
            opacity: isOpen ? 1 : 0,
        },
    });

    return {
        toggleExpand,
        isOpen,
        ref: measureRef,
        style,
    };
}
